<template>
  <div v-if="isLoggedIn && campaignData" class="bg-pink-500 text-white px-4 sm:px-6 py-2 hidden lg:block">
    <div class="max-w-6xl mx-auto">
        <nav class="flex justify-end items-center">

            <a :href='getDashboardUrl()' class="py-2 px-4 transition duration-300 ease-in-out hover:bg-pink-600">Dashboard</a>

            <a v-if="isAdmin || updateIsCurrentUserCampaignCreator()" :href="'/edit-campaign/' + campaignData.id" class="py-2 px-4 transition duration-300 ease-in-out hover:bg-pink-600">Edit Campaign</a>

            <a v-if="isAdmin || updateIsCurrentUserCampaignCreator()" :href="`/campaigns/${campaignData.id}/impact`" class="py-2 px-4 transition duration-300 ease-in-out hover:bg-pink-600">Impact Dashboard</a>

            <a href="/profile" class="py-2 px-4 transition duration-300 ease-in-out hover:bg-pink-600">Profile Settings</a>

            <div v-if="isAdmin" class="relative group" @mouseenter="showSubmenu($event, 'teamAdmin')" @mouseleave="hideSubmenu($event, 'teamAdmin')" tabindex="0">
                <button class="parent-button py-2 px-4 focus:outline-none transition duration-300 ease-in-out hover:bg-pink-600">Team Admin</button>
                <div ref="teamAdmin" class="submenu absolute left-0 mt-2 w-48 bg-white rounded-md shadow-lg z-20 opacity-0 invisible transition duration-200 ease-in-out">
                    <a href="/campaign-search" class="block px-4 py-2 text-base text-gray-700 hover:bg-pink-100">Campaigns</a>
                    <a href="/admin/users" class="block px-4 py-2 text-base text-gray-700 hover:bg-pink-100">Users</a>
                    <a href="/admin/campaign-cards" class="block px-4 py-2 text-base text-gray-700 hover:bg-pink-100">Campaign Cards</a>
                </div>
            </div>

            <div v-if="isAdmin" class="relative group" @mouseenter="showSubmenu($event, 'financial')" @mouseleave="hideSubmenu($event, 'financial')" tabindex="0">
                <button class="parent-button py-2 px-4 focus:outline-none transition duration-300 ease-in-out hover:bg-pink-600">Financial</button>
                <div ref="financial" class="submenu absolute left-0 mt-2 w-48 bg-white rounded-md shadow-lg z-20 opacity-0 invisible transition duration-200 ease-in-out">
                    <a href="/donation-search" class="block px-4 py-2 text-base text-gray-700 hover:bg-pink-100">Donations</a>
                    <a href="/admin/deposits" class="block px-4 py-2 text-base text-gray-700 hover:bg-pink-100">Deposits</a>
                    <a href="/admin/reports" class="block px-4 py-2 text-base text-gray-700 hover:bg-pink-100">Reports</a>
                </div>
            </div>

            <a href="#" @click="logout" class="py-2 px-4 transition duration-300 ease-in-out hover:bg-pink-600">Logout</a>
        </nav>
    </div>
  </div>
  <div class="sticky top-0 shadow-sm relative bg-white z-10" :class="classes">
    <div class="border-b border-gray-200">
      <div class="max-w-[1400px] mx-auto px-4 sm:px-6 md:px-12 lg:px-16">
        <div class="flex justify-between items-center py-4 md:py-8 lg:py-6 lg:justify-start md:space-x-10">
          <div class="flex justify-start items-center lg:w-0 lg:flex-1 max-w-96">
            <a :href="campaignParentName && campaignData.parent_id ? `/campaigns/${campaignData.parent_id}` : '#'" class="flex items-center" :class="{ 'flex-shrink-0': supportPageUrl }">
              <span class="sr-only">Sideout</span>
              <img v-if="campaignParentName" src="/img/side-out-iconcircle.png" alt="Side-Out Foundation" class="w-auto h-10 lg:h-12">
              <img v-if="!campaignParentName" src="/img/logo.svg" alt="Side-Out Foundation" class="w-auto h-10 lg:h-12">
            </a>
            <div v-if="campaignParentName" class="ml-3 flex items-center">
              <span class="text-black font-display text-base font-semibold leading-none uppercase mr-2">+</span>
              <span class="ml-1 text-black font-display text-base font-semibold leading-none uppercase">{{ campaignData.business_name || campaignData.name }}</span>
            </div>
          </div>

          <!-- Navigation links -->
          <nav class="hidden lg:flex items-center !ml-auto" :class="supportPageUrl ? 'space-x-2 pl-4 xl:space-x-5' : 'space-x-8'">
            <a v-if="shouldShowLinks" :href="getLinkUrl('about')" @click.prevent="handleNavClick('about')" class="text-black font-display text-sm font-semibold tracking-wider leading-none uppercase relative" :class="{ 'hover:text-pink-500': activeSection !== 'about' }">
              <span>About</span>
              <span class="absolute -bottom-2 left-0 right-0 h-0.5 bg-pink-500 transition-opacity duration-300" :class="{ 'opacity-0': activeSection !== 'about', 'opacity-100': activeSection === 'about' }"></span>
            </a>
            <a v-if="shouldShowLinks" :href="getLinkUrl('impact')" @click.prevent="handleNavClick('impact')" class="text-black font-display text-sm font-semibold tracking-wider leading-none uppercase relative" :class="{ 'hover:text-pink-500': activeSection !== 'impact' }">
              <span>Your Impact</span>
              <span class="absolute -bottom-2 left-0 right-0 h-0.5 bg-pink-500 transition-opacity duration-300" :class="{ 'opacity-0': activeSection !== 'impact', 'opacity-100': activeSection === 'impact' }"></span>
            </a>
            
            <a v-if="shouldShowLinks" :href="getLinkUrl('research')" @click.prevent="handleNavClick('research')" class="text-black font-display text-sm font-semibold tracking-wider leading-none uppercase relative" :class="{ 'hover:text-pink-500': activeSection !== 'research' }">
              <span>Free Precision Report</span>
              <span class="absolute -bottom-2 left-0 right-0 h-0.5 bg-pink-500 transition-opacity duration-300" :class="{ 'opacity-0': activeSection !== 'research', 'opacity-100': activeSection === 'research' }"></span>
            </a>

            <a v-if="shouldShowLinks" :href="getLinkUrl('activity')" @click.prevent="handleNavClick('activity')" class="text-black font-display text-sm font-semibold tracking-wider leading-none uppercase relative" :class="{ 'hover:text-pink-500': activeSection !== 'activity' }">
              <span>Activity</span>
              <span class="absolute -bottom-2 left-0 right-0 h-0.5 bg-pink-500 transition-opacity duration-300" :class="{ 'opacity-0': activeSection !== 'activity', 'opacity-100': activeSection === 'activity' }"></span>
            </a>
            <a v-if="campaignData && supportPageUrl" :href="supportPageUrl" @click="triggerSupportHub" class="text-black font-display text-sm font-semibold tracking-wider leading-none uppercase hover:text-pink-500">Support</a>
          </nav>                       
          
          <a v-if="campaignData" @click="triggerDonationModal" class="hidden lg:block cursor-pointer bg-pink hover:bg-pink-600 border-2 border-transparent text-white font-semibold text-center mb-3 md:mb-0 px-8 py-3 text-sm rounded-full transform transition-all duration-500">Donate</a>

          <button ref="menuToggle" aria-label="Open campaign menu" @click.stop="toggleMenu" v-if="shouldShowLinks" class="lg:hidden focus:outline-none">
            <svg class="w-9 h-9 text-pink-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
            </svg>
          </button>
          <button @click.stop="toggleAltMenu" v-else class="lg:hidden focus:outline-none">
            <svg class="w-9 h-9 text-pink-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
            </svg>
          </button>

        </div>
      </div>
    </div>
  </div>
  <div class="campaign-mobile-menu fixed top-0 right-0 h-full w-full bg-white shadow-lg z-20 transition-transform duration-300 ease-in-out transform translate-x-full-custom" :class="{ 'translate-x-0-custom': isMenuOpen }" :inert="!isMenuOpen" :aria-hidden="!isMenuOpen">
    <div class="p-4">
      <button aria-label="Close campaign menu" @click="toggleMenu" class="absolute top-4 right-4 focus:outline-none">
        <svg class="w-8 h-8 text-pink-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
           <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
       </button>
       <nav class="flex flex-col space-y-4 mt-14">
          <a v-if="shouldShowLinks" :href="getLinkUrl('about')" @click="handleLinkClick('about')" class="text-black font-display text-lg font-medium leading-none uppercase hover:text-gray-500 border-b border-gray-200 pb-4">About</a>
          <a v-if="shouldShowLinks" :href="getLinkUrl('impact')" @click="handleLinkClick('impact')" class="text-black font-display text-lg font-medium leading-none uppercase hover:text-gray-500 border-b border-gray-200 pb-4">Your Impact</a>
          <a v-if="shouldShowLinks" :href="getLinkUrl('research')" @click="handleLinkClick('research')" class="text-black font-display text-lg font-medium leading-none uppercase hover:text-gray-500 border-b border-gray-200 pb-4">Free Precision Report</a>
          <a v-if="shouldShowLinks" :href="getLinkUrl('activity')" @click="handleLinkClick('activity')" class="text-black font-display text-lg font-medium leading-none uppercase hover:text-gray-500 border-b border-gray-200 pb-4">Activity</a>
          <button v-if="campaignData" @click="triggerDonationModal(); toggleMenu()" class="cursor-pointer bg-pink hover:bg-pink-600 border-2 border-transparent text-white block font-medium uppercase text-center mb-3 md:mb-0 lg:px-12 py-3 text-sm rounded-full transform transition-all duration-500">DONATE</button>
          <component :is="supportPageUrl ? 'a' : 'button'" v-if="campaignData" :href="supportPageUrl || undefined" :type="supportPageUrl ? undefined : 'button'" @click="handleSupportClick" class="cursor-pointer bg-white border-2 border-pink hover:bg-pink hover:text-white text-pink block font-medium uppercase text-center py-3 text-sm rounded-full transform transition-all duration-500">Support this Campaign</component>
          <button v-if="campaignData" @click="triggerShareModal(); toggleMenu()" class="cursor-pointer bg-white border-2 border-gray-300 hover:border-pink hover:text-pink text-black block font-medium uppercase text-center py-3 text-sm rounded-full transform transition-all duration-500">Share</button>
        </nav>
    </div>
  </div>

  <div class="campaign-mobile-menu fixed top-0 right-0 h-full w-full bg-white shadow-lg z-20 transition-transform duration-300 ease-in-out transform translate-x-full-custom" :class="{ 'translate-x-0-custom': isAltMenuOpen }" :inert="!isAltMenuOpen" :aria-hidden="!isAltMenuOpen">
    <div class="p-4">
      <button @click="toggleAltMenu" class="absolute top-4 right-4 focus:outline-none">
        <svg class="w-8 h-8 text-pink-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
           <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
       </button>
       <nav class="flex flex-col space-y-4 mt-14">
          <a :href="getLinkUrl('about')" @click="handleLinkClick('about')" class="text-black font-display text-lg font-medium leading-none uppercase hover:text-gray-500 border-b border-gray-200 pb-4">About</a>
          <a :href='getDashboardUrl()' class="text-black font-display text-lg font-medium leading-none uppercase hover:text-gray-500 border-b border-gray-200 pb-4">Dashboard</a>
          <a v-if="campaignData && (isAdmin || updateIsCurrentUserCampaignCreator())" :href="'/edit-campaign/' + campaignData.id" @click="toggleAltMenu" class="text-black font-display text-lg font-medium leading-none uppercase hover:text-gray-500 border-b border-gray-200 pb-4">Edit Campaign</a>
          <a v-if="campaignData && (isAdmin || updateIsCurrentUserCampaignCreator())" :href="`/campaigns/${campaignData.id}/impact`" @click="toggleAltMenu" class="text-black font-display text-lg font-medium leading-none uppercase hover:text-gray-500 border-b border-gray-200 pb-4">Impact Dashboard</a>
          <a href="/profile" class="text-black font-display text-lg font-medium leading-none uppercase hover:text-gray-500 border-b border-gray-200 pb-4">Profile Settings</a>
          
          <div v-if="isAdmin" class="relative">
            <button @click="toggleSubmenu('teamAdmin')" class="text-black font-display text-lg font-medium leading-none uppercase hover:text-gray-500 border-b border-gray-200 pb-4 w-full text-left flex justify-between items-center">
              Team Admin
              <svg class="w-4 h-4 transform transition-transform duration-200" :class="{ 'rotate-180': submenuOpen.teamAdmin }" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path></svg>
            </button>
            <div v-show="submenuOpen.teamAdmin" class="pl-4 mt-2 space-y-2">
              <a href="/campaign-search" class="block text-black font-display text-base leading-none hover:text-gray-500 uppercase py-2">Campaigns</a>
              <a href="/admin/users" class="block text-black font-display text-base leading-none hover:text-gray-500 uppercase py-2">Users</a>
              <a href="/admin/campaign-cards" class="block text-black font-display text-base leading-none hover:text-gray-500 uppercase py-2">Campaign Cards</a>
            </div>
          </div>
          
          <div v-if="isAdmin" class="relative">
            <button @click="toggleSubmenu('financial')" class="text-black font-display text-lg font-medium leading-none uppercase hover:text-gray-500 border-b border-gray-200 pb-4 w-full text-left flex justify-between items-center">
              Financial
              <svg class="w-4 h-4 transform transition-transform duration-200" :class="{ 'rotate-180': submenuOpen.financial }" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path></svg>
            </button>
            <div v-show="submenuOpen.financial" class="pl-4 mt-2 space-y-2">
              <a href="/donation-search" class="block text-black font-display text-base leading-none hover:text-gray-500 uppercase py-2">Donations</a>
              <a href="/admin/deposits" class="block text-black font-display text-base leading-none hover:text-gray-500 uppercase py-2">Deposits</a>
              <a href="/admin/reports" class="block text-black font-display text-base leading-none hover:text-gray-500 uppercase py-2">Reports</a>
            </div>
          </div>
          
          <a href="#" @click="logout" class="text-black font-display text-lg font-medium leading-none uppercase hover:text-gray-500 border-b border-gray-200 pb-4">Logout</a>
        </nav>      
    </div>
  </div>
</template>

<script>
  import { scrollToInPageAnchor } from '../../composables/useInPageScroll';
  import { cleanCampaignShareUrl, isUnmodifiedPrimaryClick } from '../../composables/useCampaignShare';

  export default {
    name: 'TopHeaderV2',
    props: {
      supportPageUrl: { type: String, default: null },
      user: {
        type: Object,
        default: null
      },
      classes: {
        type: String,
        default: ''
      },
    },
    data() {
      return {
        isOpen: false,
        activeSection: null,
        isMenuOpen: false,
        isAltMenuOpen: false,
        campaignData: this.$store.state.campaignWidget.campaign, // Initialize from the store
        submenuOpen: {
          teamAdmin: false,
          financial: false
        }
      }
    },
    watch: {
      isMenuOpen() { this.emitMenuState() },
      isAltMenuOpen() { this.emitMenuState() },
      '$store.state.campaignWidget.campaign': {
        handler(newCampaign) {
          this.campaignData = newCampaign; // Update the data property when the store changes
          // Only warn if business_name is missing when it's needed (partner campaigns)
          if (this.campaignData && this.campaignParentName && !this.campaignData.business_name) {
            console.warn('business_name is not available for partner campaign:', this.campaignData);
          }
        },
        immediate: true
      }
    },
    methods: {
      emitMenuState() {
        this.emitter.emit('campaign-mobile-menu-state', this.isMenuOpen || this.isAltMenuOpen)
      },
      showSubmenu(event, ref) {
        const submenu = this.$refs[ref];
        submenu.style.opacity = '1';
        submenu.style.visibility = 'visible';
      },
      hideSubmenu(event, ref) {
        const submenu = this.$refs[ref];
        submenu.style.opacity = '0';
        submenu.style.visibility = 'hidden';
      },
      updateIsCurrentUserCampaignCreator() {
        return this.isLoggedIn && this.campaignData && this.user.id === this.campaignData.user_id;
      },
      navigateToCreateCampaign() {
        window.location.href = '/create-my-campaign/' + this.campaignData.id;
        this.toggleMenu();
      },
      handleLinkClick(section) {
        if (this.isCreatingCampaign) {
          // If creating a campaign, follow the link without toggling the menu
          window.location.href = this.getLinkUrl(section);
        } else {
          // If not creating a campaign, scroll to the section and toggle the menu closed
          this.scrollToSection(section);
          this.toggleMenu();
        }
      },
      getLinkUrl(linkVal) {
        if (this.campaignIdFromUrl) {
          return `/campaigns/${this.campaignIdFromUrl}#${linkVal}`;
        }
        return `#${linkVal}`;
      },
      closeMenu(event) {
        // Check if the clicked element is not within either menu's container
        const menuContainer = event.target.closest('.fixed.top-0.right-0.h-full.w-full.bg-white.shadow-lg.z-20.transition-transform.duration-300.ease-in-out.transform');
        if (!menuContainer) {
          if (this.isMenuOpen) {
            this.toggleMenu();
          }
          if (this.isAltMenuOpen) {
            this.toggleAltMenu();
          }
        }
      },
      toggleMenu(event) {
        if (event) {
          event.stopPropagation();
        }
        this.isMenuOpen = !this.isMenuOpen;
      },
      toggleAltMenu(event) {
        if (event) {
          event.stopPropagation();
        }
        this.isAltMenuOpen = !this.isAltMenuOpen;
        console.log('Alt menu toggled:', this.isAltMenuOpen); // Add this line for debugging
      },
      onScroll() {
        const sections = ['about', 'impact', 'research', 'activity'];
        const scrollPosition = window.scrollY;
        // Activation band (170) must be at least as wide as scrollToSection's
        // landing offset — header height + breathing room, now owned by
        // useInPageScroll.js (desktop 97+20=117, mobile 80+80=160) — so the nav
        // marker lights up the moment a click completes, not 17-70px of extra
        // scroll later. If you change those offsets in the helper, keep this band
        // >= the larger (mobile) total.
        const headerHeight = 170;
        const bottomThreshold = 100; // Adjust this value according to your desired threshold

        let activeSection = null;

        for (let i = 0; i < sections.length; i++) {
          const section = document.getElementById(sections[i]);
          if (section) {
            const sectionTop = section.offsetTop - headerHeight;
            const sectionBottom = sectionTop + section.offsetHeight;

            if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
              activeSection = sections[i];
              break;
            }
          }
        }

        // Check if the scroll position is near the bottom of the page
        const documentHeight = document.documentElement.scrollHeight;
        const windowHeight = window.innerHeight;
        if (scrollPosition + windowHeight >= documentHeight - bottomThreshold) {
          activeSection = 'activity';
        }

        this.activeSection = activeSection;
      },
      scrollToSection(sectionId) {
        // The shared helper owns the sticky-header offset so every in-page
        // anchor lands at the same y-position. Falls back to an error log
        // when the section id isn't on the page (preserves prior behavior;
        // the verbose debug logging that used to live here was dev cruft).
        if (!scrollToInPageAnchor(sectionId)) {
          console.error('Section not found:', sectionId);
        }
      },
      triggerDonationModal() {
        this.emitter.emit('open-donation-modal-from-campaign', {
          returnFocus: this.isMenuOpen ? this.$refs.menuToggle : document.activeElement,
        });
      },
      triggerSupportModal() {
        if (this.isMenuOpen) this.$refs.menuToggle?.focus({ preventScroll: true })
        this.emitter.emit('open-support-modal');
      },
      triggerSupportHub(event) {
        if (!isUnmodifiedPrimaryClick(event)) return;
        event?.preventDefault?.();
        // Support Hub (fundraise + share takeover). The anchor keeps the
        // shareable /campaigns/{id}/support href for copy/open-in-new-tab;
        // a plain click opens the hub in place.
        this.emitter.emit('open-support-hub', {
          returnFocus: this.isMenuOpen ? this.$refs.menuToggle : (event?.currentTarget || document.activeElement),
        });
      },
      handleSupportClick(event) {
        if (this.supportPageUrl) {
          if (!isUnmodifiedPrimaryClick(event)) return;
          this.triggerSupportHub(event);
        } else {
          this.triggerSupportModal();
        }
        this.toggleMenu();
      },
      triggerShareModal() {
        if (!this.campaignData) return;
        this.emitter.emit('open-share-dialog', {
          returnFocus: this.isMenuOpen ? this.$refs.menuToggle : document.activeElement,
          campaignId: this.campaignData.id,
          campaignName: this.campaignData.name,
          url: cleanCampaignShareUrl(),
          qrUrl: `${window.location.origin}/qr/${this.campaignData.id}`,
        });
      },
      setOpenToFalse() {
        this.isOpen = false;
      },
      logout() {
        let token = document.head.querySelector('meta[name="csrf-token"]');
        axios.post('/logout', {_token: token.content})
            .then(response => {
              window.location.href = '/login'
            })
      },
      getDashboardUrl() {
        if (this.isLoggedIn) {
          if (this.isAdmin) {
            return '/admin/campaign/active-foundation';
          }
          return '/active-campaigns';
        }
        return ''; // Redirect to login or another appropriate action
      },
      handleNavClick(section) {
        if (this.isCreatingCampaign) {
          window.location.href = this.getLinkUrl(section);
        } else {
          this.scrollToSection(section);
        }
      },
      toggleSubmenu(submenu) {
        this.submenuOpen[submenu] = !this.submenuOpen[submenu];
      }
    },
    mounted() {
      window.addEventListener('scroll', this.onScroll);
      document.body.addEventListener('click', this.closeMenu);
      // Fetch the campaign data if necessary
      if (!this.campaignData) {
        this.campaignData = this.$store.state.campaignWidget.campaign;
      }
    },
    beforeUnmount() {
      this.emitter.emit('campaign-mobile-menu-state', false)
      window.removeEventListener('scroll', this.onScroll);
      document.body.removeEventListener('click', this.closeMenu);
    },
    computed: {
      isLoggedIn() {
        return this.user !== null;
      },
      isAdmin() {
        return this.isLoggedIn && this.user.is_admin;
      },
      isCurrentUserCampaignCreator() {
        return this.isLoggedIn && this.campaignData && this.user.id === this.campaignData.user_id;
      },
      shouldShowLinks() {
        const url = window.location.pathname;
        return url.includes('/campaigns/') && !url.includes('/create-my-campaign/');
      },
      campaignIdFromUrl() {
        const url = window.location.pathname;
        const match = url.match(/\/create-my-campaign\/(\d+)/);
        return match ? match[1] : null;
      },
      isCreatingCampaign() {
        return window.location.pathname.includes('/create-my-campaign/');
      },
      menuClass() {
        return this.isMenuOpen ? 'translate-x-0' : 'translate-x-full';
      },
      token() {
        return $('meta[name="csrf-token"]').attr('content')
      },
      campaignName() {
        return this.$store.state.campaignWidget.campaignName;
      },
      campaignParentName() {
        return this.$store.state.campaignWidget.campaignParentName;
      },
      pledgeId() {
          return this.$store.state.campaignWidget.pledgeId;
      }
    },
  }
</script>
<style>
.campaign-mobile-menu {
  height: 100vh;
  height: 100dvh;
  overflow-y: auto;
  overscroll-behavior-y: contain;
  padding-bottom: env(safe-area-inset-bottom);
}
.translate-x-full-custom {
  transform: translateX(100%);
}

.translate-x-0-custom {
  transform: translateX(0);
}

.group:hover .group-hover\:block {
  display: block;
  animation: fadeIn 0.2s;
}

.group-hover\:block:hover {
  display: block;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.group:hover .group-hover\:opacity-100, .group:focus-within .group-focus-within\:opacity-100 {
  opacity: 1;
}

.group:hover .parent-button,
.group:focus-within .parent-button {
  background-color: #c41677 /* pink-600 */;
}

.submenu {
  transition: opacity 0.2s, visibility 0.2s;
}
</style>
